import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { type ProductSection } from '../../entity/api/product-section';
import { createBasicStoreState } from './basic-store';

type TModel = ProductSection;

/**
 * Product Sections Zustand Store
 *
 * This store now only provides:
 * - Basic store methods (clearStore, updateToStore, updateMultipleToStore, etc.) for socket updates
 * - Sync state for socket handlers
 *
 * For data access, use TanStack Query cache helpers from product-sections-queries.ts:
 * - getProductSectionsByProductIdFromCache(queryClient, productId)
 * - setProductSectionsInCache(queryClient, productId, sections)
 * - updateProductSectionsInCache(queryClient, productId, sections)
 * - updateProductSectionInCache(queryClient, productId, section)
 * - removeProductSectionFromCache(queryClient, productId, sectionId)
 *
 * Or use the useProductSectionsByProductId hook from products-queries.ts
 */
type FullStoreState = ReturnType<typeof createBasicStoreState<TModel>>;

export const useStore = create<FullStoreState>()(
  devtools(
    function (set, get) {
      return {
        ...createBasicStoreState<TModel>(set, get),
      };
    },
    { name: 'blym', store: 'product-sections' }
  )
);
